import {
    listMissionStudyAnswers,
    type MissionStudyStoredAnswer,
    type MissionId,
} from '@wwf/sdk';
import type { DataProvider, GetListParams } from 'react-admin';
import { toHttpError } from '@core/api';

function toStudyAnswerRow(missionId: MissionId, row: MissionStudyStoredAnswer) {
    return {
        id: row.answerId,
        missionId,
        ...row,
    };
}

export const missionStudyAnswerProvider: Partial<DataProvider> = {
    getList: async (_resource, params) => {
        const filter = (params as GetListParams).filter as
            | { missionId?: MissionId }
            | undefined;
        const missionId = filter?.missionId;
        if (!missionId) {
            throw new Error(
                'missionStudyAnswer list requires filter.missionId'
            );
        }

        try {
            const answers = await listMissionStudyAnswers(missionId);
            const data = answers.map(row => toStudyAnswerRow(missionId, row));
            return { data: data as any[], total: data.length };
        } catch (e) {
            throw toHttpError(e);
        }
    },
};
